import { c as _c } from "react/compiler-runtime";
import { IcoEye16, IcoFileText16, IcoSparkles16 } from '@onefootprint/icons';
import type { ResourceContext } from '@onefootprint/request-types/percy';
import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import type { SuggestedAction } from '../components/suggested-actions';
import { presentResource } from '../utils/resource-presentation';
import { CURSOR_MARKER } from '../utils/seed-text';
import { useResourceContextSelection } from './use-resource-context-selection';
export const resolveSuggestedPrompt = (prompt: string, context: ResourceContext, t: TFunction<'copilot'>): string | null => {
  if (!prompt.includes(CURSOR_MARKER)) return prompt;
  const name = presentResource(context, t)?.name;
  if (!name) return null;
  return prompt.replace(CURSOR_MARKER, name);
};
export const useSuggestedActions = () => {
  const $0 = _c(13);
  const {
    t
  } = useTranslation("ask-percy");
  const {
    t: tCopilot
  } = useTranslation("copilot");
  const {
    effectiveContext
  } = useResourceContextSelection();
  if (!effectiveContext) {
    let t0;
    if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = [];
      $0[0] = t0;
    } else {
      t0 = $0[0];
    }
    return t0;
  }
  if (effectiveContext.kind === "agent") {
    let t0;
    if ($0[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = ["review", "missing", "rules"];
      $0[1] = t0;
    } else {
      t0 = $0[1];
    }
    let t1;
    if ($0[2] !== t) {
      t1 = (t0 as const).map(key => {
        const prompt = t($ => $.actionPills.agentBuilder[key]);
        return {
          id: `agent_${key}`,
          label: prompt,
          icon: IcoSparkles16,
          prompt
        };
      });
      $0[2] = t;
      $0[3] = t1;
    } else {
      t1 = $0[3];
    }
    return t1;
  }
  if (effectiveContext.kind === "playbook") {
    let t0;
    if ($0[4] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = ["explain", "review", "gaps"];
      $0[4] = t0;
    } else {
      t0 = $0[4];
    }
    let t1;
    if ($0[5] !== t) {
      t1 = (t0 as const).map(key_0 => {
        const prompt_0 = t($_0 => $_0.actionPills.playbookDetail[key_0]);
        return {
          id: `playbook_${key_0}`,
          label: prompt_0,
          icon: IcoSparkles16,
          prompt: prompt_0
        };
      });
      $0[5] = t;
      $0[6] = t1;
    } else {
      t1 = $0[6];
    }
    return t1;
  }
  if (effectiveContext.kind === "entity") {
    let t0;
    if ($0[7] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = _temp;
      $0[7] = t0;
    } else {
      t0 = $0[7];
    }
    let t1;
    if ($0[8] !== effectiveContext || $0[9] !== t || $0[10] !== tCopilot) {
      const candidates = [{
        id: "summarize_entity",
        label: t(t0),
        icon: IcoEye16,
        prompt: t(_temp2)
      }, {
        id: "generate_report",
        label: t(_temp3),
        icon: IcoFileText16,
        prompt: t(_temp4)
      }];
      t1 = candidates.flatMap(action => {
        const prompt_1 = resolveSuggestedPrompt(action.prompt, effectiveContext, tCopilot);
        return prompt_1 ? [{
          ...action,
          prompt: prompt_1
        }] : [];
      });
      $0[8] = effectiveContext;
      $0[9] = t;
      $0[10] = tCopilot;
      $0[11] = t1;
    } else {
      t1 = $0[11];
    }
    return t1;
  }
  let t0;
  if ($0[12] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $0[12] = t0;
  } else {
    t0 = $0[12];
  }
  return t0;
};
function _temp($_1) {
  return $_1.actionPills.summarize;
}
function _temp2($_2) {
  return $_2.actionPills.directActions.summarize.prompt;
}
function _temp3($_3) {
  return $_3.actionPills.generateReport;
}
function _temp4($_4) {
  return $_4.actionPills.directActions.generateReport.prompt;
}